<template lang="pug">
yz-filter-menu(:label="$t('panel.claim_number')" :is-active="isActive" :display-value="displayValue" :disable-apply="!claimNumber || claimNumber.trim() === ''" @clear="onClear" @apply="onApply")
  .pa-4
    yz-text-field(v-model="claimNumber" :label="$t('panel.claim_number')" :placeholder="$t('panel.enter_claim_number')" size="lg")
</template>

<script>
export default {
  props: {
    filter: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      claimNumber: '',
      isActive: false,
      displayValue: ''
    }
  },
  methods: {
    onClear() {
      this.claimNumber = ''
      this.isActive = false
      this.displayValue = ''
      this.$emit('update:filter', {})
    },
    onApply() {
      this.isActive = true
      this.displayValue = this.claimNumber

      this.$emit('update:filter', {
        key: 'rid',
        value: this.claimNumber.trim()
      })
    },
    reset() {
      this.onClear()
    },
    restoreFromParams(params) {
      // Restore filter state from URL params
      if (params.rid) {
        this.claimNumber = params.rid
        this.onApply()
      }
    }
  }
}
</script>
